import { Footer, ThemeProvider } from "@deere/fuel-react";
import Link from "@mui/material/Link";
import Tooltip from "@mui/material/Tooltip";
import { withOktaAuth } from "@okta/okta-react";
import React, { Component } from "react";
import "./App.css";
import AppHeader from "./common/header";
import AppSwitch from "./components/AppSwitch";

const REPORT_ISSUE_URL =
  process.env.REACT_APP_REPORT_ISSUE_URL ||
  "https://johndeere.service-now.com/ep?id=sc_cat_item&sys_id=70545f2d13f66e88b43fbcaf3244b0b7"
  ;

class App extends Component {
  componentDidMount() {
    if (!this.props.authState.isAuthenticated) {
      this.props.authService.logout();
    }
  }

  render() {
    return (
      <ThemeProvider>
        <AppHeader />
        <div className="main-conatiner">
          <AppSwitch />
        </div>
        <div id="footer">
          <Footer>
            <Tooltip
              title='When submitting an incident, please ask to assign the ticket to "Channel IT DSS R2 Financial Solutions Support Tier 3".'
              arrow
            >
              <Link
                href={REPORT_ISSUE_URL}
                rel="noopener noreferrer"
                target="_blank"
                       >
                Report an Issue - IT4U
              </Link>
            </Tooltip>
          </Footer>
        </div>
      </ThemeProvider>
    );
  }
}

export default withOktaAuth(App);
